import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaInfoCircle, FaLeaf, FaSeedling, FaEnvelope } from 'react-icons/fa';
import './Navbar.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location]);

  const navLinks = [
    { path: '/about', label: 'About', icon: <FaInfoCircle /> },
    { path: '/services', label: 'Services', icon: <FaLeaf /> },
    { path: '/plants', label: 'Products', icon: <FaSeedling /> },
    { path: '/contact', label: 'Contact', icon: <FaEnvelope /> },
  ];

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''} ${menuOpen ? 'menu-open' : ''}`}>
      <div className="nav-container">
        {/* Left: Logo */}
        <Link to="/" className="nav-logo">
          <img src="/images/logo.png" alt="Nisarg Plant Library Pvt. Ltd." className="logo-image" style={{ height: '45px', width: 'auto' }} />
        </Link>
        {/* Center spacer */}
        <div className="nav-spacer" />
        {/* Right: Navigation Links and CTA */}
        <ul className="nav-links">
          {navLinks.map(({ path, label, icon }) => (
            <li key={path}>
              <Link
                to={path}
                className={`nav-link ${location.pathname === path ? 'active' : ''}`}
              >
                <span className="nav-link-icon">{icon}</span>
                {label}
                <span className="nav-underline" />
              </Link>
            </li>
          ))}
        </ul>
        {/* Right: CTA Button */}
        <Link to="/contact" className="nav-cta">
          <span>Get a Quote</span>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </Link>
        {/* Hamburger */}
        <button
          className={`hamburger ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation menu"
          id="hamburger-btn"
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        <ul>
          {navLinks.map(({ path, label, icon }) => (
            <li key={path}>
              <Link
                to={path}
                className={`mobile-link ${location.pathname === path ? 'active' : ''}`}
                onClick={() => setMenuOpen(false)}
              >
                <span className="mobile-link-icon">{icon}</span>
                {label}
              </Link>
            </li>
          ))}
          <li>
            <Link to="/contact" className="mobile-cta" onClick={() => setMenuOpen(false)}>
              Get a Quote
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
